export const DOMAIN_SUFFIX = ["com", "biz", "info", "name", "net", "org"];
